/*
 * @Author: your name
 * @Date: 2021-10-12 15:43:36
 * @LastEditTime: 2025-05-07 16:46:14
 * @LastEditors: lyt
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /official_web_portal/official/src/router/index.js
 */
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/V2/Home.vue"),
    redirect: "/first",
    children: [
      // 首页
      {
        path: "/first",
        name: "First",
        component: () => import("@/views/V2/home/index.vue"),
      },
      // 公司介绍
      {
        path: "/introduce",
        name: "Introduce",
        component: () => import("@/views/V2/introduce/index.vue"),
      },
      // 创新产品
      {
        path: "/product",
        name: "Product",
        component: () => import("@/views/V2/product/index.vue"),
      },
      // 解决方案
      {
        path: "/solve",
        name: "Solve",
        component: () => import("@/views/V2/solveMethods/index.vue"),
      },
      // 公司动态
      {
        path: "/dynamic",
        name: "Dynamic",
        component: () => import("@/views/V2/dynamic/index.vue"),
      },
      // 公司内部动态
      {
        path: "/internal",
        name: "Internal",
        component: () => import("@/views/V2/dynamic/Internal.vue"),
      },
      // 首页
      {
        path: "/relations",
        name: "Relations",
        component: () => import("@/views/V2/relations/index.vue"),
      },
      // 业绩报告
      {
        path: "/Achievement",
        name: "Achievement",
        component: () => import("@/views/V2/relations/Achievement.vue"),
      },
      // 公司公告
      {
        path: "/Announce",
        name: "Announce",
        component: () => import("@/views/V2/relations/Announce.vue"),
      },
      // 公司治理
      {
        path: "/government",
        name: "government",
        component: () => import("@/views/V2/relations/government.vue"),
      },
      // 投资者服务
      {
        path: "/Service",
        name: "Service",
        component: () => import("@/views/V2/relations/Service.vue"),
      },
      {
        path: "/joinus",
        name: "joinus",
        component: () => import("@/views/V2/joinUs/index.vue"),
      },
      {
        path: "/recruit",
        name: "recruit",
        component: () => import("@/views/V2/joinUs/recruit.vue"),
      },
      // 招聘考试
      {
        path: "/examList",
        name: "/examList",
        component: () => import("@/views/V2/joinUs/examList.vue"),
      },
    ],
  },
  {
    // 离职证明
    path: "/lzzm",
    name: "/lzzm",
    component: () => import("@/views/V2/dimissionCertify/index.vue"),
  },
];
const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

export default router;
